<!-- 建国课程 -->
<template>
    <!-- 上滑加载组件 -->
    <cp-page-scroll
       v-show="courseList.length"
       @load="load"
       :upFinish="upFinish"
        ref="pageScroll"
        :isref="isref"
    >
  <common-list v-if="courseList.length" :courseList="courseList" :tabIndex="tabIndex"></common-list>
  </cp-page-scroll>
</template>

<script>
import CommonList from './model/common-list.vue'
import { course } from '@/agent'
export default {
  name: 'ModelCourse',
  props: {
    filterId: { // 筛选条件
      default: ''
    },
    tabIndex: {
      type: String,
      default: ''
    },
  },
  components: {
    'common-list': CommonList
  },
  data () {
    return {
      courseList: [],
      params: {
        pageNum: 1,
        pageSize: 10,
        query: {
          seriesId: 0 // 分类课程tabs请求type
        },
      },
      upFinish: false, // 是否已加载全部
      isref: true,
    }
  },
  computed: {
  },
  watch: {
    filterId: {
      immediate: true, // 很重要！！！
      handler (val) {
        if (val) {
          this.params.query.seriesId = this.filterId
          this.params.pageNum = 1
          this.courseList = []
          this.getListOfTopSeries(true)
        }
      }
    }
  },
  mounted () {
  },
  methods: {
    // 上滑加载
    load () {
      this.getListOfTopSeries()
    },
    // 头部轮播图和tablist
    getListOfTopSeries (resetList = false) {
      this.$loading.show()
      let param = {
        ...this.params,
        sorts: [
          {
            sortPropertyName: 'year',
            sortType: 'ISNULL'
          },
          {
            sortPropertyName: 'year',
            sortType: 'ASC'
          },
          {
            sortPropertyName: 'month',
            sortType: 'ISNULL'
          },
          {
            sortPropertyName: 'month',
            sortType: 'ASC'
          },
          {
            sortPropertyName: 'day',
            sortType: 'ISNULL'
          },
          {
            sortPropertyName: 'day',
            sortType: 'ASC'
          },
          {
            sortPropertyName: 'modifyTime',
            sortType: 'DESC'
          }
        ]
      }
      course.getListOfTopSeries(param).then(res => {
        if (res.code == 100) {
          this.$loading.hide()
          this.courseList = resetList ? res.data.list : [...this.courseList, ...res.data.list]
          if (this.params.pageNum >= res.data.pages) {
            this.upFinish = true
            this.isref = false
          } else {
            this.params.pageNum += 1
            this.upFinish = false
            this.isref = true
          }
        } else {
          this.isref = false // 请求失败下次不可以请求
          this.upFinish = true// 显示 没有更多了
        }
        this.$refs.pageScroll.hideLoading() // 底部加载loading隐藏
        console.log(this.courseList)
      })
    }
  }
}

</script>
